module.exports = __webpack_public_path__ + "static/media/materialNetworkLogoCenteredDark-2x.6eebee7f.png";